module.exports = __webpack_public_path__ + "static/media/news-cdphp-postpartum.f1c14f2f.jpg";